import * as React from "react";
const SvgFiBrandsBluetooth = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M20.525 23.004h.181c.06.004.12-.014.168-.05a.17.17 0 0 0 .064-.14c0-.126-.084-.195-.232-.195h-.181zm.375.494-.231-.393h-.144v.404h-.133v-.979h.344a.4.4 0 0 1 .136.021.4.4 0 0 1 .107.063.3.3 0 0 1 .07.094.25.25 0 0 1 .026.115.26.26 0 0 1-.061.172.3.3 0 0 1-.158.105l-.044.015.24.395zm-.218-1.29a.9.9 0 0 0-.325.06.8.8 0 0 0-.261.172.8.8 0 0 0-.176.257.84.84 0 0 0 0 .628.8.8 0 0 0 .176.257.846.846 0 0 0 1.17 0 .7.7 0 0 0 .177-.257.84.84 0 0 0 0-.628.8.8 0 0 0-.176-.257.8.8 0 0 0-.262-.172.9.9 0 0 0-.323-.06m0 1.738a1 1 0 0 1-.377-.073 1 1 0 0 1-.305-.209.9.9 0 0 1-.218-.295.9.9 0 0 1 0-.722.97.97 0 0 1 .513-.496 1 1 0 0 1 .377-.07 1 1 0 0 1 .379.07q.175.077.307.21.137.127.218.294a.9.9 0 0 1 0 .722 1 1 0 0 1-.218.295.97.97 0 0 1-.676.274"
    />
    <path
      fill="#151A2D"
      d="M12.5 24c5.449 0 9.22-2.49 9.22-12S17.96 0 12.5 0 3.28 2.49 3.28 12s3.771 12 9.22 12m-1.197-12-4.47-4.3 1.295-1.255 3.564 3.429V1.682l6.476 6.214L13.89 12l4.276 4.103-6.473 6.214v-8.192L8.14 17.544l-1.295-1.255zm2.208 6.068 2.067-1.986-2.067-1.982zm0-12.149 2.067 1.986-2.067 1.982z"
    />
  </svg>
);
export default SvgFiBrandsBluetooth;
